import axios from 'axios';
import rutasrep from '@/assets/utils/rutas.json';


export const fetchArchivosPlanos = async (
  especialidad = '',
  fechaDesde = '',
  fechaHasta = '',
  desde = 0,
  hasta = 15,
) => {
  const query = `
    query qrallPlano(
      $doctorId: ID, $pacienteid: ID, $tipocobertura: String!
      $tiposeguro: String!, $especialidad: String!, $tipoarchivo: String!,
      $fechaDesde: String!, $fechaHasta: String!
    ){
      allPlanos(
        doctorid: $doctorId, pacienteid: $pacienteid,
        tipocobertura: $tipocobertura, tiposeguro: $tiposeguro,
        especialidad: $especialidad, tipoarchivo: $tipoarchivo,
        fechadesde: $fechaDesde, fechahasta: $fechaHasta, 
      ){
        total
        message
        status
        aplano{
          id
          usuarioCreador{
            username
          }
          doctor{
            idPersona{
              primerNombre
              primerApellido
            }
          }
          paciente{
            persona{
              primerNombre
              primerApellido
            }
          }
          fechaproceso
          finicio
          ffin
          tipocobertura{
            descripcion
          }
          especialidad {
            descripcion
          }
          tipoarchivo
          estadoarchivo
        }
      }
    }
  `;
  try {
    const varConsulta = {
      doctorId: '',
      pacienteid: '',
      tipocobertura: '',
      tiposeguro: '',
      especialidad: '',
      tipoarchivo: '',
      fechaDesde: '',
      fechaHasta: '',
    }
    const response = await axios.post(rutasrep.axiosrep + "api", {
      query,
      variables: varConsulta,
    });
    if (response.status === 200) {
      if (response.data.data.allPlanos.status === "success") {
        if (response.data.data.allPlanos.aplano) {
          this.itemsAP = response.data.data.allPlanos.aplano.map((item) => {
            return {
              id: item.id,
              paciente: item.paciente ? item.paciente.persona.primerApellido + ' ' + item.paciente.persona.primerNombre : 'Pacientes activos',
              doctor: item.doctor ? `${item.doctor.idPersona.primerNombre} ${item.doctor.idPersona.primerApellido}` : '',
              fechaproceso: item.fechaproceso,
              fechainicio: item.finicio,
              fechafin: item.ffin,
              especialidad: item.especialidad.descripcion,
              tipocobertura: item.tipocobertura ? item.tipocobertura.descripcion : '',
              tipoarchivo: this.opsSoloLIP.find(op => String(op.value) === item.tipoarchivo).text,
              usuario: item.usuarioCreador ? item.usuarioCreador.username : '',
            };
          });
          this.totalRows = response.data.data.allPlanos.total;
          this.currentPage = 1;
          this.currentPageModificado = pagina_actual;
        } else {
          this.itemsAP = [];
          this.totalRows = 0;
          this.currentPage = 1;
          this.currentPageModificado = pagina_actual;
        }
      }
    }
  } catch (error) {
    console.error('An error occurred while fetching the options:', error);
  }
}


export const generarArchivoPlano = async ( variables ) => {

  const query = `
    mutation genaplano(
      $idpaciente: String
      $iddoctor: String
      $fechaDesde: String
      $fechaHasta: String
      $pacdoc: String
      $establecimiento : ID
      $fechaproceso: String
      $tiposeguro: String!
      $tipocobertura: String!
      $especialidad: String!
      $pservicio: String!
    ) {
      crearArchivoPlano(
        idpaciente: $idpaciente
        iddoctor: $iddoctor
        finicio: $fechaDesde
        ffin: $fechaHasta
        pacdoc: $pacdoc
        establecimiento : $establecimiento
        fechaproceso: $fechaproceso
        tiposeguro: $tiposeguro
        tipocobertura: $tipocobertura
        especialidad: $especialidad
        tiposervicio: $pservicio
      ) {
        archivoplano {
          id
        }
        status
        message
      }
    }
  `;

  try {

    const response = await axios.post(rutasrep.axiosrep + "api", { query, variables });

    // console.log(response);
    return response.data.data.crearArchivoPlano;

  } catch (error) {
    console.log(error);
    return "Error al generar el archivo plano";
  }

}



export const descargarArchivoPlano = async (idarchivo) => {

  let idA = idarchivo;
  idA = idA.toString();
  const query = `
    query qAplano($idarchivo : ID!) {
      archivoPlanoxls(aplanoid : $idarchivo) {
        xlsarchivo
      }
    }
  `;
  try {
    const response = await axios.post(rutasrep.axiosrep + "api", {
      query,
      variables: {
        idarchivo: idA,
      },
    });
    if (response.data.data.archivoPlanoxls) {
      return response.data.data.archivoPlanoxls.xlsarchivo
      // actions.cargarArchivos(data, "aplano.csv", "data:text/csv;base64");
    } 
  } catch (error) {
    console.error(error)
    return error;
  }
}


export const obtenerDataTablePlanos = async (params = {}) => {

  console.log('params', params);
  
  const { page, pageSize } = params;

  const query = `
    query MyQuery(
      $page: Int, 
      $pageSize: Int
    ) {
      allPlanos(
        page: $page, 
        pageSize: $pageSize
      ) {
        message
        status
        total
        aplano {
          urlcarpeta
          avance
          usuarioCreador {
            username
          }
          id
          especialidad
          establecimiento
          {
            id
            Descripcion
          }
          estado
          estadoarchivo
          fechaCreacion
          fechaproceso
          finicio
          ffin
          segurosalud
          tipocobertura
          tiposervicio
          doctor {
            id
            idPersona {
            primerNombre
            primerApellido
            identificacion
            }
          }
          paciente {
            id
            persona {
            primerNombre
            primerApellido
            identificacion
            }
          }
        }
      }
    }
  `;

  const variables = {
    page,
    pageSize
  };
  
  try {
    const response = await axios.post(rutasrep.axiosrep + "api", { query, variables });
    
    if (response.status !== 200) return null;

    const response2 = response.data.data.allPlanos;
    if (!response2) return null;

    return {
      total: response2.total,
      data: response2.aplano
    };

  } catch (error) {
    console.log("Error al obtener la data table");
    return error;
  }

}